export const PAGE_VIEW_SWITCH = 'PAGE_VIEW_SWITCH';

export const pageViewSwitch = (view) => {
  return {
    type: PAGE_VIEW_SWITCH,
    view
  }
};
